export const KEYBOARD_SHORTCUT_SEARCH = "/";
